import { useConfigClientModuleManager } from '@/ui/hooks/useConfigClientModulesManager'

export function ConfigClientModulesManager({
  children
}: {
  children: (props: {
    checkPermissionModulesAndReturn: <T>(module: string, toReturn: T) => T[]
  }) => React.ReactNode
}) {
  const { checkPermissionModulesAndReturn } = useConfigClientModuleManager()

  return children({
    checkPermissionModulesAndReturn
  })
}
